module.exports = __webpack_public_path__ + "static/lexus_0-cb2a92f90f0ab181840d1c171cceffad.jpg";